import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Section, SectionTitle } from './Shared';
export function IsForYou() {
  return <div className="bg-cream" data-id="element-99">
      <Section className="max-w-3xl" data-id="element-100">
        <SectionTitle data-id="element-101">¿Este método es para vos?</SectionTitle>

        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-beige-muted/50 mt-8" data-id="element-102">
          <div className="space-y-5" data-id="element-103">
            {['Si tu bebé se despierta muchas veces por noche', 'Si ya probaste de todo y nada funcionó', 'Si no querés dejarlo llorar', 'Si querés resultados reales y un plan claro'].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-104">
                <CheckCircle2 className="w-6 h-6 text-cta flex-shrink-0 mt-0.5" data-id="element-105" />
                <p className="text-lg text-charcoal font-medium" data-id="element-106">{item}</p>
              </div>)}
          </div>
        </div>
      </Section>
    </div>;
}